export default __webpack_public_path__ + "static/media/backgroundMobile2.52086dfe.svg";